import React from "react";
import "pure-react-carousel/dist/react-carousel.es.css";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  Image,
} from "pure-react-carousel";

const NaytaLiuku = (props) => {
  const { tila, kuvat } = props;
  let i = -1;
  const lkm = Object.values(kuvat).length;
  const wid = tila.frisbee ? 800 : 1000;
  const hei = tila.frisbee ? 570 : 1000;
  const end = tila.frisbee ? "_800.webp" : "_1000.jpg";
  const html = Object.values(kuvat).map((e) => {
    i++;
    return (
      <Slide index={i} className="liukuTila" key={i}>
        <Image
          hasMasterSpinner={true}
          src={
            "/frisbeeapuri/" + kuvat[i] + (kuvat[i] === "liikemerkki" ? "_1000.png" : end)
          }
          alt={`Kuva ${i + 1}`}
        />
      </Slide>
    );
  });
  return (
    <div>
      <CarouselProvider
        naturalSlideWidth={wid}
        naturalSlideHeight={hei}
        totalSlides={lkm}
      >
        <Slider className="liuku">{html}</Slider>
        <ButtonBack children="<" className="liukuNappi" />
        &nbsp;
        <ButtonNext children=">" className="liukuNappi" />
      </CarouselProvider>
    </div>
  );
};
export default NaytaLiuku;
